import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import { getItinerarySupplierFoodReportColumns } from '../../../../config/columns';
import Table from '../../../common/Table';
import Loader from '../../../common/Loader';
import Alert from '../../../common/informative/Alert';
import { THERE_ARE_NOT_DATA_TO_SHOW } from '../../../../config/messages';
import { filterMethodCaseInsensitive } from '../../../../utils/filter-methods';
import { clearItinerarySupplierFoodReport } from '../../../../actions/food/ItinerarySupplierFood';

export const ItinerarySupplierFoodReportResult = ({
  dispatchClearItinerarySupplierFoodReport,
  loading,
  itinerarySupplierFoods,
}) => {
  useLayoutEffect(() => () => dispatchClearItinerarySupplierFoodReport(), []);

  const data = Array.from(itinerarySupplierFoods.values());

  let table = <Alert message={THERE_ARE_NOT_DATA_TO_SHOW} />;

  if (loading) table = <Loader />;

  if (!loading && data.length > 0) {
    table = (
      <>
        <Table
          manual={false}
          columns={getItinerarySupplierFoodReportColumns()}
          data={data}
          defaultPageSize={100}
          required
          loading={loading}
          filterable
          defaultFilterMethod={filterMethodCaseInsensitive}
          getTbodyProps={() => ({ className: 'body-scrollable' })}
        />
      </>
    );
  }

  return table;
};

const mapStateToProps = ({ FoodUnit }) => ({
  loading: FoodUnit.ItinerarySupplierFood.getIn(['report', 'loading']),
  itinerarySupplierFoods: FoodUnit.ItinerarySupplierFood.getIn([
    'report',
    'content',
    'content',
  ]),
});

const mapDispatchToProps = {
  dispatchClearItinerarySupplierFoodReport: clearItinerarySupplierFoodReport,
};

ItinerarySupplierFoodReportResult.propTypes = {
  itinerarySupplierFoods: PropTypes.instanceOf(Immutable.List).isRequired,
  loading: PropTypes.bool,
  dispatchClearItinerarySupplierFoodReport: PropTypes.func.isRequired,
};

ItinerarySupplierFoodReportResult.defaultProps = {
  loading: false,
};

const formComponent = reduxForm({
  form: 'ItinerarySupplierFoodReportResult',
})(ItinerarySupplierFoodReportResult);

export default connect(mapStateToProps, mapDispatchToProps)(formComponent);
